<!--
 * @Descripttion: 
 * @version: 
 * @Author: etong
 * @Date: 2020-10-29 13:32:02
 * @LastEditors: etong
 * @LastEditTime: 2020-11-27 15:27:23
-->
<template>
  <div :style="{height:height+'px',zIndex:zIndex}">
    <div :class="[className, 'w100']" :style="{top:stickyTop+'px',zIndex:zIndex,position:position,height:height+'px',bottom:stickyBottom+'px'}">
      <slot>
        <div>sticky</div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sticky",
  props: {
    stickyTop: {
      type: Number,
      default: 0
    },
    stickyBottom: {
      type: Number,
      default: 0
    },
    zIndex: {
      type: Number,
      default: 1
    },
    className: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      active: false,
      position: "",
      width: undefined,
      height: undefined,
      isSticky: false
    };
  },
  mounted() {
    this.width = this.$el.getBoundingClientRect().width;
    this.height = this.$el.getBoundingClientRect().height;
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleReize);
  },
  activated() {
    // this.width = this.$el.getBoundingClientRect().width + 'px';
    // this.reset();
    this.handleScroll();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleReize);
  },
  methods: {
    sticky() {
      if (this.active) {
        return;
      }
      this.position = "fixed";
      this.active = true;
      this.width = this.width + "px";
      this.isSticky = true;
    },
    reset() {
      if (!this.active) {
        return;
      }
      this.position = "fixed";
      this.width = this.width + "px";
      this.active = false;
      this.isSticky = false;
    },
    handleScroll() {
      this.width = this.$el.getBoundingClientRect().width;
      const offsetTop = this.$el.getBoundingClientRect().top;
      if (offsetTop < this.stickyTop) {
        this.sticky();
        return;
      }
      this.reset();
    },
    handleReize() {
      if (this.isSticky) {
        this.width = this.$el.getBoundingClientRect().width + "px";
      }
    }
  }
};
</script>
